import { Location } from '@angular/common';
import { Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { filter, firstValueFrom } from 'rxjs';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { MasterSolutionEnums } from 'src/app/enum/master-solution-Enums';
import { WindowEnums } from 'src/app/enum/window-enums';
import { CustomListDropdown } from 'src/app/interfaces/custom-list/custom-list-dropdown.interface';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { MasterSolutionModel } from 'src/app/models/preliminaries/master-solution.model';
import { OptionWindowService } from 'src/app/services/authentication/option-window.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { MasterSolutionService } from 'src/app/services/preliminaries/master-solution.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-register-master-solution',
  templateUrl: './register-master-solution.component.html',
  styleUrls: ['./register-master-solution.component.scss'],
  standalone: false
})
export class RegisterMasterSolutionComponent implements OnInit {

  branchId: number = 0;
  companyId: number = 0;
  disabledForm: boolean = true;
  formMasterSolution: FormGroup = new FormGroup({});
  iconState: string = '';
  isOpened: string | undefined = undefined;
  listBranches: CustomListDropdown[] = [];
  masterSolutionContract: MasterSolutionModel = new MasterSolutionModel();
  masterSolutionId: number = 0;
  nameWindow: string = 'Captura Maestra Soluciones';
  permissionPrint: boolean = false;
  permissionUpdatable: boolean = false;
  permissionsUser: OptionWindowModel[] = [];
  projectName = ProjectName.projectName;
  quantityDetails: number = 0;
  severityState: string = '';
  stateMasterSolution: string = '';
  titleState: string = '';
  url: string = 'master-solution';
  userAuthenticated: UserModel = new UserModel();

  constructor(private activatedRoute: ActivatedRoute,
    private branchService: BranchService,
    private formBuilder: FormBuilder,
    private formControlStateService: FormControlStateService,
    private headerService: HeaderService,
    private location: Location,
    private masterSolutionService: MasterSolutionService,
    private optionWindowService: OptionWindowService,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService,
    private windowService: WindowService) {
    this.validateForm(new MasterSolutionModel());
  }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    await this.getPermission();
    this.activatedRoute.params.subscribe(params => {
      this.masterSolutionId = Object.keys(params).length > 0 ? params?.id : null;
    });
    this.handleInitialState();
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  async changeBranch(branchId: number) {
    this.branchId = branchId;
    this.masterSolutionId = 0;
    this.masterSolutionContract = new MasterSolutionModel();
    this.masterSolutionContract.branchId = branchId;
    this.validateForm(this.masterSolutionContract);
    this.location.replaceState(`/${this.url}/register`);
  }

  async changeConsecutive(consecutive: number) {
    if (!consecutive || consecutive < 0 || this.masterSolutionContract.consecutive === consecutive) {
      return;
    }
    const branchId = this.formMasterSolution.get('branchId')?.value;
    if (!branchId) {
      this.toastHandlerService.showToast('warning', 'Seleccione una sucursal.');
      return;
    }
    try {
      const response = await firstValueFrom(this.masterSolutionService.getMasterSolutionByKeysAsync(branchId, consecutive));
      this.masterSolutionId = response.masterSolutionId;
      this.masterSolutionContract = response;
      this.validateForm(this.masterSolutionContract);
      this.location.replaceState(`/${this.url}/register/${this.masterSolutionId}`);
    } catch (error) {
      console.error('Error al buscar la solución por código.', error);
    }
  }

  async changeState() {
    const { masterSolutionState, masterSolutionId } = this.masterSolutionContract;
    if (!masterSolutionId || masterSolutionId === 0) {
      this.toastHandlerService.showToast('warning', 'Debe crear una solución.');
      return;
    }
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('error', `No tiene permisos para cambiar el estado de la solución.
        Comuníquese con el administrador del sistema.`);
      return;
    }
    try {
      const response = await firstValueFrom(this.masterSolutionService.changeStateAsync(masterSolutionId));
      this.masterSolutionContract = response;
      this.validateForm(this.masterSolutionContract);
      const successMessage = masterSolutionState == MasterSolutionEnums.open ? 'La solución fue abierta exitosamente.'
        : 'La solución fue cerrada exitosamente.';
      this.toastHandlerService.showToast('success', successMessage);
    } catch (error) {
      console.error('Error al cambiar el estado de la solución.', error);
    }
  }

  createNewRegister() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('error', `El usuario no tiene permisos para crear soluciones.
        Comuníquese con el administrador del sistema.`);
      return;
    }
    this.masterSolutionId = 0;
    this.masterSolutionContract = new MasterSolutionModel();
    this.masterSolutionContract.branchId = this.branchId;
    this.validateForm(this.masterSolutionContract);
    this.location.replaceState(`/${this.url}/register`);
  }

  async delete() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('error', `El usuario no tiene permisos para eliminar soluciones.
        Comuníquese con el administrador del sistema.`);
      return;
    }
    if (!this.masterSolutionId || this.masterSolutionId === 0) {
      this.toastHandlerService.showToast('warning', 'Debe crear una solución.');
      return;
    }
    const result = await Swal.fire({
      title: 'Atención',
      text: '¿Realmente desea eliminar la solución?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí',
      cancelButtonText: 'No',
    });
    if (!result.isConfirmed) return;
    try {
      await firstValueFrom(this.masterSolutionService.deleteAsync(this.masterSolutionContract.masterSolutionId));
      this.createNewRegister();
      this.toastHandlerService.showToast('success', 'La solución fue eliminada exitosamente.');
    } catch (error) {
      console.error('Error al eliminar la solución.', error);
    }
  }

  async getAllBranches() {
    try {
      const response = await firstValueFrom(this.branchService.getAllBranchesForSelectAsync());
      this.listBranches = response;
    } catch (error) {
      console.error('Error al cargar las sucursales.', error);
    }
  }

  async getButtonClick(buttonClick: any) {
    const branchId = this.formMasterSolution.get("branchId")?.value;
    const consecutive = this.formMasterSolution.get("consecutive")?.value;
    if (!branchId) {
      this.toastHandlerService.showToast('warning', 'Seleccione una sucursal.');
      return;
    }
    this.handleMasterSolutionNavigation(buttonClick, branchId, consecutive)
  }

  async getFirstBranchByUserAuthenticatedAsync() {
    try {
      const response = await firstValueFrom(
        this.userAuthenticatedService.branchObservable.pipe(
          filter(branch => !!branch && branch.branchId !== 0)
        )
      );
      this.branchId = response.branchId;
      await this.getAllBranches();
    } catch (error) {
      console.error('Error al obtener la primera sucursal del usuario autenticado.', error);
    }
  }

  async getMasterSolutionById() {
    try {
      const response = await firstValueFrom(this.masterSolutionService.getByIdAsync(this.masterSolutionId));
      this.masterSolutionId = response.masterSolutionId;
      this.masterSolutionContract = response;
      this.validateForm(this.masterSolutionContract);
      this.location.replaceState(`/${this.url}/register/${this.masterSolutionId}`);
    } catch (error) {
      console.error('Error al obtener la solución por id.', error);
    }
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast('error', `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`);
      }
    } else {
      localStorage.clear();
    }
    await Promise.all([
      this.getPermissionProfileByUrl(),
      this.getPermissionsForUserByWindow(),
      this.getUserAuthenticated(),
      this.getFirstBranchByUserAuthenticatedAsync(),
    ]);
  }

  async getPermissionsForUserByWindow() {
    try {
      this.permissionsUser = await firstValueFrom(this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.MasterSolution));
    } catch (error) {
      console.error('Error al cargar los permisos del usuario.', error);
    }
  }

  async getUserAuthenticated() {
    try {
      this.userAuthenticated = await firstValueFrom(
        this.userAuthenticatedService.userObservable.pipe(
          filter(user => user && user.userId !== 0)
        )
      );
    } catch (error) {
      console.error('Error al obtener el usuario autenticado.', error);
    }
  }

  async getPermissionProfileByUrl() {
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
    } catch (error) {
      console.error('Error al buscar los permisos del perfil.', error);
    }
  }

  async handleInitialState() {
    if (this.masterSolutionId !== null && this.masterSolutionId !== 0) {
      await this.getMasterSolutionById();
    } else {
      this.createNewRegister();
    }
  }

  async handleMasterSolutionNavigation(buttonClick: any, branchId: number, consecutive: number) {
    const actionMap: Record<string, () => Promise<MasterSolutionModel>> = {
      first: () => firstValueFrom(this.masterSolutionService.getFirstMasterSolutionByKeysAsync(branchId)),
      previus: () => firstValueFrom(this.masterSolutionService.getPreviusMasterSolutionByKeysAsync(branchId, consecutive)),
      next: () => firstValueFrom(this.masterSolutionService.getNextMasterSolutionByKeysAsync(branchId, consecutive)),
      last: () => firstValueFrom(this.masterSolutionService.getLastMasterSolutionByKeysAsync(branchId)),
    };
    const action = actionMap[buttonClick.target.id];
    if (!action) {
      this.masterSolutionId = 0;
      this.masterSolutionContract = new MasterSolutionModel();
      this.masterSolutionContract.branchId = branchId;
      return;
    }
    try {
      const masterSolution = await action();
      this.masterSolutionId = masterSolution.masterSolutionId;
      this.masterSolutionContract = masterSolution;
      this.validateForm(this.masterSolutionContract);
      this.location.replaceState(`/${this.url}/register/${this.masterSolutionId}`);
    } catch (error) {
      console.error(`Error al buscar la solución (${buttonClick.target.id}).`, error);
    }
  }

  async send() {
    this.validateFormControls();
    if (this.formMasterSolution.valid) {
      const modelMasterSolution = this.formMasterSolution.getRawValue() as MasterSolutionModel;
      if (modelMasterSolution.alterCode == "") modelMasterSolution.alterCode = null;
      if (this.masterSolutionId == 0) {
        try {
          const response = await firstValueFrom(this.masterSolutionService.createAsync(modelMasterSolution));
          this.masterSolutionId = response.masterSolutionId;
          this.masterSolutionContract = response;
          this.validateForm(this.masterSolutionContract);
          this.location.replaceState(`/${this.url}/register/${this.masterSolutionId}`);
          this.toastHandlerService.showToast('success', 'La solución fue creada exitosamente.');
        } catch (error) {
          console.error('Error al crear la solución.', error);
        }
      } else {
        this.masterSolutionContract.alterCode = modelMasterSolution.alterCode;
        this.masterSolutionContract.name = modelMasterSolution.name;
        this.masterSolutionContract.description = modelMasterSolution.description;
        try {
          const response = await firstValueFrom(this.masterSolutionService.updateAsync(this.masterSolutionContract));
          this.masterSolutionContract = response;
          this.validateForm(this.masterSolutionContract);
          this.toastHandlerService.showToast('success', 'La solución fue modificada exitosamente.');
        } catch (error) {
          console.error('Error al actualizar la solución.', error);
        }
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      branchId: {
        required: 'El campo Sucursal es obligatorio.',
        min: 'Debes seleccionar una Sucursal válida.'
      },
      alterCode: {
        maxlength: 'El campo Cod.Alt no puede tener más de 10 caracteres.'
      },
      name: {
        required: 'El campo Nombre es obligatorio.',
        maxlength: 'El campo Nombre no puede tener más de 1000 caracteres.'
      },
      description: {
        required: 'El campo Descripción es obligatorio.',
        maxlength: 'El campo Descripción no puede tener más de 1000 caracteres.'
      },
      masterSolutionState: {
        required: 'El campo Estado es obligatorio.',
        min: 'Debes seleccionar un Estado válido.'
      }
    };
    Object.keys(controlMessages).forEach(control => {
      const formControl = this.formMasterSolution.get(control);
      if (formControl && formControl.invalid && formControl.errors) {
        const messages = controlMessages[control];
        Object.keys(formControl.errors).forEach(errorKey => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message, 'Atención');
          }
        });
      }
    });
  }

  updateFormState(masterSolution: MasterSolutionModel) {
    const stateConfig: any = {
      [MasterSolutionEnums.open]: {
        icon: 'pi pi-lock-open',
        title: 'Cerrar',
        text: 'Abierto',
        severityState: 'danger',
        disabledForm: false,
      },
      [MasterSolutionEnums.closed]: {
        icon: 'pi pi-lock',
        title: 'Abrir',
        text: 'Cerrado',
        severityState: 'success',
        disabledForm: true
      }
    };
    const currentState = stateConfig[masterSolution.masterSolutionState];
    if (currentState) {
      this.iconState = currentState.icon;
      this.titleState = currentState.title;
      this.stateMasterSolution = currentState.text;
      this.severityState = currentState.severityState;
      this.disabledForm = currentState.disabledForm;
      if (masterSolution.masterSolutionState == MasterSolutionEnums.open) {
        if (this.masterSolutionId != 0) {
          setTimeout(() => this.formMasterSolution.controls["consecutive"].enable());
        } else {
          setTimeout(() => this.formMasterSolution.controls["consecutive"].disable());
        }
      } else {
        setTimeout(() => {
          this.formMasterSolution.disable();
          this.formControlStateService.setControlState(this.formMasterSolution, ['branchId', 'consecutive'], true);
        });
      }
      if (!this.permissionUpdatable) {
        setTimeout(() => {
          this.formMasterSolution.disable();
          this.formControlStateService.setControlState(this.formMasterSolution, ['branchId', 'consecutive'], true);
        });
        this.disabledForm = true;
      }
    }
  }

  validateForm(masterSolution: MasterSolutionModel) {
    this.formMasterSolution = this.formBuilder.group({
      branchId: [masterSolution.branchId, [Validators.required, Validators.min(1)]],
      consecutive: [masterSolution.consecutive],
      alterCode: [masterSolution.alterCode],
      name: [masterSolution.name, [Validators.required, Validators.max(66)]],
      description: [masterSolution.description, [Validators.required, Validators.max(250)]],
      masterSolutionState: [masterSolution.masterSolutionState, [Validators.required, Validators.min(1)]],
    })
    this.updateFormState(masterSolution);
  }

  validateFormControls() {
    Object.keys(this.formMasterSolution.controls).forEach((key) => {
      const control = this.formMasterSolution.get(key);
      if (control && control.invalid) {
        console.warn(
          `${key} es inválido`,
          control.errors,
          'value:',
          control.value
        );
      }
    });
  }
}
